import React from "react";
import SharedLayout from "./SharedLayout";

const CorporateView = ({ user, onLoginClick }) => {
  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div
        style={{
          maxWidth: "1700px",
          margin: "0 auto",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            marginBottom: "2rem",
            color: "#2c3e50",
            fontSize: "2rem",
          }}
        >
          Corporate
        </h1>
        <div
          style={{
            background: "white",
            padding: "3rem",
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <p
            style={{
              fontSize: "1.5rem",
              color: "#7f8c8d",
              fontWeight: "300",
            }}
          >
            Coming soon.
          </p>
        </div>
      </div>
    </SharedLayout>
  );
};

export default CorporateView;
